module.exports = __webpack_public_path__ + "img/V4.06453645.png";